<template>
  <div class="Warning">
    <topTitle title="联系我们" :list="list" :newData="newData"></topTitle>
    <h1>项目现场</h1>
    <p>
      地址：浙江省宁波市东钱湖旅游度假区，环湖东路环湖东路716号 
      <br /><span class="kongbai"></span>（原横街村）
      <br/>贵宾热线：0574——55559888
    </p>
    
    <div class="amap-page-container">
      <el-amap vid="amapDemo" :zoom="zoom" :center="center" class="amap-demo">
        <el-amap-marker vid="component-marker" :position="componentMarker.position" :content-render="componentMarker.contentRender" ></el-amap-marker>
        <el-amap-marker v-for="(marker, index) in markers" :key="index" :position="marker.position" :events="marker.events" :visible="marker.visible" :draggable="marker.draggable" :vid="index"></el-amap-marker>
      </el-amap>
     
    </div>
  </div>
</template>
  <script>
import topTitle from "../rightTopTitle";
 const exampleComponents = {
      props: ['text'],
      template: ``
    }
export default {
  name: "Warning",
  data() {
    return {
      list: [
        {
          title: "联系我们",
          small_title: "CONTACT US",
          hasTitle: "联系我们",
          show: false,
        },
        {
          title: "加入我们",
          small_title: "PROJECT INTRODUCTION",
          hasTitle: "加入我们",
        },
      ],
      newData:0,
         count: 1,
          slotStyle: {
            padding: '2px 8px',
            background: '#eee',
            color: '#333',
            border: '1px solid #aaa'
          },
          zoom: 14,
          center: [121.705794,29.740844],
          markers: [
            {
              position: [121.705794,29.740844],
              events: {
                click: () => {
               
                },
                dragend: (e) => {
                
                  this.markers[0].position = [e.lnglat.lng, e.lnglat.lat];
                }
              },
              visible: true,
              draggable: false,
              template: '<span>1</span>',
            }
          ],
          renderMarker: {
            position: [121.5273285, 31.21715058],
            contentRender: (h, instance) => {
              // if use jsx you can write in this
              // return <div style={{background: '#80cbc4', whiteSpace: 'nowrap', border: 'solid #ddd 1px', color: '#f00'}} onClick={() => ...}>marker inner text</div>
              return h(
                'div',
                {
                  style: {background: '#80cbc4', whiteSpace: 'nowrap', border: 'solid #ddd 1px', color: '#f00'},
                  on: {
                    click: () => {
                      const position = this.renderMarker.position;
                      this.renderMarker.position = [position[0] + 0.002, position[1] - 0.002];
                    }
                  }
                },
                ['marker inner text']
              )
            }
          },
          componentMarker: {
            position: [121.5273285, 31.21315058],
            contentRender: (h, instance) => h(exampleComponents,{style: {backgroundColor: '#fff'}, props: {text: 'father is here'}}, ['xxxxxxx'])
          },
          slotMarker: {
            position: [121.5073285, 31.21715058]
          }
    };
  },
  methods: {
      onClick() {
          this.count += 1;
        },
        changePosition() {
          let position = this.markers[0].position;
          this.markers[0].position = [position[0] + 0.002, position[1] - 0.002];
        },
        chnageDraggle() {
          let draggable = this.markers[0].draggable;
          this.markers[0].draggable = !draggable;
        },
        toggleVisible() {
          let visableVar = this.markers[0].visible;
          this.markers[0].visible = !visableVar;
        },
        addMarker() {
          let marker = {
            position: [121.5273285 + (Math.random() - 0.5) * 0.02, 31.21515044 + (Math.random() - 0.5) * 0.02]
          };
          this.markers.push(marker);
        },
        removeMarker() {
          if (!this.markers.length) return;
          this.markers.splice(this.markers.length - 1, 1);
        }
  },
  mounted: function () {},
  components: {
    topTitle,
  },
  props: {
   
 
  },
};
</script>
<style scoped="scoped">
h1 {
  text-align: left;
  margin-top: 0.7rem;
  color: #3f674b;
  font-size: 0.475rem;
}
p {
    margin-top: 0.675rem;
  font-size:0.4rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 0.675rem;
  text-align: left;
}
.amap-demo {
    margin-top: 0.5rem;
    width: 12.5rem;
      height: 6.8125rem;
    }
    .kongbai{
      display: inline-block;
      width: 0.9375rem;
    }
</style>